var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-password-change py-5"},[_c('AwlCard',{attrs:{"title":"Recupera password"}},[_c('ResetPasswordChangeForm',{staticClass:"card-body"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }